<section class="security-flow">
  <ol class="email-steps" [attr.aria-label]="'app.profileSettings.securityModal.email.stepsAriaLabel' | translate">
    <li class="email-steps__item email-steps__item--active">
      <span>1</span>
      <div>
        <strong>{{ 'app.profileSettings.securityModal.email.steps.newEmail.title' | translate }}</strong>
        <p>{{ 'app.profileSettings.securityModal.email.steps.newEmail.body' | translate }}</p>
      </div>
    </li>
    <li class="email-steps__item">
      <span>2</span>
      <div>
        <strong>{{ 'app.profileSettings.securityModal.email.steps.verify.title' | translate }}</strong>
        <p>{{ 'app.profileSettings.securityModal.email.steps.verify.body' | translate }}</p>
      </div>
    </li>
    <li class="email-steps__item">
      <span>3</span>
      <div>
        <strong>{{ 'app.profileSettings.securityModal.email.steps.confirm.title' | translate }}</strong>
        <p>{{ 'app.profileSettings.securityModal.email.steps.confirm.body' | translate }}</p>
      </div>
    </li>
  </ol>

  <hr class="horizontal color-300">

  <div class="security-flow__content">
    <div class="field">
      <label for="currentSecurityEmail">{{ 'app.profileSettings.securityModal.email.currentEmail' | translate }}</label>
      <div class="readonly-input">
        <span>{{ currentEmail() }}</span>
        <app-icon icon="icon-lock-regular.svg" color="currentColor" />
      </div>
    </div>

    <div class="field">
      <label for="securityEmail">{{ 'app.profileSettings.securityModal.email.newEmail' | translate }}</label>
      <p>{{ 'app.profileSettings.securityModal.email.newEmailHelp' | translate }}</p>
      <input id="securityEmail" type="email" [ngModel]="model().email" (ngModelChange)="onEmailChange($event)"
        [placeholder]="'app.profileSettings.securityModal.email.newEmailPlaceholder' | translate" />
    </div>

    <div class="info-callout">
      <strong>{{ 'app.profileSettings.securityModal.email.importantTitle' | translate }}</strong>
      <p>{{ 'app.profileSettings.securityModal.email.importantBody' | translate }}</p>
    </div>

    <div class="check-list">
      <h4>{{ 'app.profileSettings.securityModal.email.whatHappensTitle' | translate }}</h4>
      <p><i class="fa-solid fa-check" aria-hidden="true"></i>{{ 'app.profileSettings.securityModal.email.whatHappens.verifyCode' | translate }}</p>
      <p><i class="fa-solid fa-check" aria-hidden="true"></i>{{ 'app.profileSettings.securityModal.email.whatHappens.currentActive' | translate }}</p>
      <p><i class="fa-solid fa-check" aria-hidden="true"></i>{{ 'app.profileSettings.securityModal.email.whatHappens.logout' | translate }}</p>
    </div>
  </div>

  <footer class="security-flow__footer">
    <button type="button" class="safegpt-button inverted" (click)="cancelled.emit()">{{ 'common.actions.back' | translate }}</button>
    <button type="button" class="safegpt-button" (click)="update.emit()">{{ 'common.actions.continue' | translate }}</button>
  </footer>
</section>
